export default __webpack_public_path__ + "static/media/workph.330ceff9.jpg";